import { Box, styled } from '@mui/material';

export const StyledTwoColumnBox = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 24px;
  height: 100%;
`;
